// extracted by mini-css-extract-plugin
export default {"wrapper":"ResetSearchButton_wrapper__JjLn2"};